import { createReducer, ActionType, createAction } from "typesafe-actions";

export type AppSate = {
  disableRedirect: boolean;
};

export const setDisableRedirect = createAction("@app/SET_DISABLE_REDIRECT")<
  boolean,
  void
>();

export type AppAction = ActionType<typeof setDisableRedirect>;

export const appReducer = createReducer<AppSate, AppAction>({
  disableRedirect: false,
}).handleAction(setDisableRedirect, (state, action) => {
  return { ...state, disableRedirect: action.payload };
});
